<template>
  <div v-if="hasStaticMedia" class="static-data-container">
    <img alt="static-image" class="static-image d-none d-lg-inline-block" v-if="session.step_static_data.image"
         :src="session.step_static_data.image.file" @error="setAltImg($event)" />
    <img alt="static-image-tablet" class="static-image-tablet d-none d-lg-none d-md-inline-block" v-if="session.step_static_data.image_tablet"
         :src="session.step_static_data.image_tablet.file" @error="setAltImg($event)" />
    <img alt="static-image-mobile" class="static-image-mobile d-md-none d-sm-inline-block" v-if="session.step_static_data.image_mobile"
         :src="session.step_static_data.image_mobile.file" @error="setAltImg($event)" />

    <iframe v-if="session.step_static_data.embed_code"
            frameborder="0" allowfullscreen
            :src="session.step_static_data.embed_code"
    ></iframe>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'StepMedia',
  computed: {
    ...mapState(['session']),
    hasStaticMedia: function() {
      return this.session && this.session.step_static_data && (this.session.step_static_data.image || this.session.step_static_data.embed_code)
    }
  },
  methods: {

  }
}
</script>

<style scoped>
</style>
